export default {
  namespaced: true,
  state: {
    livestreams: []
  },

  getters: {
    data: state => state.livestreams,
    dataForCurrentArea: (state, getters, rootState, rootGetters) => getters.data.find(data => data.area_id === rootGetters.getCurrentAreaFirebaseId)
  },

  mutations: {
    LIVESTEAMS(state, value) {
      state.livestreams = value
    },
  }
};
